import React from 'react';
import { scrollToSection } from '../../utils/helpers';
import { Mail, Phone, MapPin } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  
  const handleNavigation = (path: string) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  
  return (
    <footer className="bg-black-900 text-white py-12 md:py-16">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand Column */}
          <div className="col-span-1 md:col-span-2 lg:col-span-1">
            <img 
              src="https://nnhioeyroijmrflqutee.supabase.co/storage/v1/object/public/njordai//NJORD%20W.png" 
              alt="Njord AI Automation Agency Logo"
              className="h-28 mb-4"
            />
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Quick Links</h4>
            <ul className="space-y-2">
              {[
                { label: 'Blog', path: '/blog' },
                { label: 'Services', target: 'services' },
                { label: 'About Us', target: 'about' },
                { label: 'Why Njord', target: 'features' },
                { label: 'Results', target: 'reviews' },
                { label: 'Book a Demo', target: 'contact' },
              ].map((link, index) => (
                <li key={index}>
                  {link.path ? (
                    <button 
                      onClick={() => handleNavigation(link.path)}
                      className="text-white hover:text-primary-300 transition-colors text-left"
                    >
                      {link.label}
                    </button>
                  ) : (
                    <button
                      onClick={() => scrollToSection(link.target)}
                      className="text-white hover:text-primary-300 transition-colors"
                    >
                      {link.label}
                    </button>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Our Services</h4>
            <ul className="space-y-2">
              {[
                { name: 'AI Consulting', path: '/ai-consultation' },
                { name: 'GEO', path: '/geo' },
              ].map((service, index) => (
                <li key={index}>
                  <button 
                    onClick={() => handleNavigation(service.path)}
                    className="text-white hover:text-primary-300 transition-colors text-left"
                  >
                    {service.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <Mail className="h-5 w-5 mr-2 mt-0.5 text-primary-300" />
                <a 
                  href="mailto:info@njordai.co.uk"
                  className="text-white hover:text-primary-300 transition-colors"
                >
                  info@njordai.co.uk
                </a>
              </li>
              <li className="flex items-start">
                <Phone className="h-5 w-5 mr-2 mt-0.5 text-primary-300" />
                <a 
                  href="tel:+447737031147"
                  className="text-white hover:text-primary-300 transition-colors"
                >
                  +44 7737 031147
                </a>
              </li>
              <li className="flex items-start">
                <MapPin className="h-5 w-5 mr-2 mt-0.5 text-primary-300" />
                <span className="text-white">Corby, United Kingdom</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 text-center">
          <p className="text-white">&copy; {currentYear} NjordAI. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;